import styled from 'styled-components'

export const RevenueCardContainer = styled.div<{ windowHeight: number }>`
  background: #fff;
  width: 100%;
  min-height: 284px;
  border-radius: 20px;
  padding: 16px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 495px;
  // height: ${({ windowHeight }) => (windowHeight < 600 ? '495px' : '284px')};
`

export const NoRevenueLabel = styled.p`
  text-align: center;
  margin: 10px;
  font-weight: 700;
`
